export default function initAccordion() {
    const accordionBtns = document.querySelectorAll('.js-accordion-btn');

    if (!accordionBtns.length) return;

    accordionBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            const currentItem = btn.closest('.js-accordion-item');
            const isExpanded = btn.getAttribute('aria-expanded') === 'true';

            // Fechar os outros caso queira que apenas um fique aberto por vez
            // Comente o bloco abaixo se quiser permitir múltiplos abertos
            document.querySelectorAll('.js-accordion-item').forEach(item => {
                if (item !== currentItem) {
                    item.classList.remove('--is-active');
                    item.querySelector('.js-accordion-btn').setAttribute('aria-expanded', 'false');
                }
            });

            // Alternar estado do item clicado
            if (isExpanded) {
                btn.setAttribute('aria-expanded', 'false');
                currentItem.classList.remove('--is-active');
            } else {
                btn.setAttribute('aria-expanded', 'true');
                currentItem.classList.add('--is-active');
            }
        });
    });
}